import * as Yup from 'yup';
import moment from 'moment';
import editarTerminal from './editarTerminalFormModel';
const {
  formField: {

    // DATOS AREA 
    name,
    description,
    typeTerminal

  }

} = editarTerminal;


export default [


  Yup.object().shape({ 
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),    
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),
    [typeTerminal.name]: Yup.object().shape({
          value: Yup.string().required(),
          label: Yup.string().required()
        }).default(undefined) // 👈 
        .required(`${typeTerminal.requiredErrorMsg}`),
  })
  
  
]; 

    